import React, {useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory} from "react-router";
import style from './card.scss'
import {Form} from "react-bootstrap";
import {Card} from "@/entity/Card";
import {addCard} from "@/api/card";
import MButton from "@/components/atom/MButton";
import {addTemporaryFile} from "@/api/file";
import {TemporaryFile} from "@/entity/TemporaryFile";

const Upload = () => {
  const history = useHistory()
  const [card, setCard] = useState(new Card({}))

  const readFile = (e) => {
    handleFile(e, 'tmpFileId')
  }

  const readBackSideFile = (e) => {
    handleFile(e, 'backSideTmpFileId')
  }

  const handleFile = (e, filePropName) => {
    e.preventDefault()
    if (!e.target.files.length) {
      return
    }
    let file = e.target.files[0]
    let fr = new FileReader()
    fr.onload = async (event) => {
      const dataURI = event.target.result
      const contents = dataURI.split(',')[1] || dataURI
      const temporaryFile = await addTemporaryFile({ temporaryFile: new TemporaryFile({ mime: file.type, contents }) })
      const prop = { ...card }
      prop[filePropName] = temporaryFile.id
      setCard(new Card({...prop }))
    }
    fr.readAsDataURL(file)
  }

  const save = async () => {
    await addCard({ card })
    history.push(`/card`)
  }

  const goBack = () => {
    history.push(`/menu`)
  }

  return (
    <>
      <Layout category={'WA'}>
        <div className={style.dataContainer}>
          <div className={style.title}>
            名刺画像を登録します。
          </div>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>名刺名称</Form.Label>
              <Form.Control type="text" value={card.name} onChange={(e) => setCard(new Card({...card, name: e.target.value }))} placeholder="名称を入力してください。" />
              <Form.Text className="text-muted">
                名刺の名称です。例えば「営業用その1」など、用途によって名前をつけてください。
              </Form.Text>
            </Form.Group>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>名刺ファイル(表面)を選択します。</Form.Label>
              <Form.Control onInput={readFile} type="file" accept="image/*" />
            </Form.Group>
            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>名刺ファイル(裏面)を選択します。後からでも反映出来ます。</Form.Label>
              <Form.Control onInput={readBackSideFile} type="file" accept="image/*" />
            </Form.Group>
            <MButton image={'touroku.png'} value={'登録'} onClick={save} disabled={!card.canUpload()}></MButton>
            <MButton image={'back.png'} value={'戻る'} onClick={ goBack }></MButton>
          </Form>
        </div>
      </Layout>
    </>
  )
}

export default Upload
